export enum SelectPanelKey {
    Tab = 'Tab',
    Enter = 'Enter',
    Escape = 'Escape',
}
